import { IJwtObject } from "@/types/jwt";
import { jwtDecode } from "jwt-decode";

export const getLangFromRefreshToken = (refreshToken: string) => {
  return jwtDecode<IJwtObject>(refreshToken).lang;
};
